import { render, staticRenderFns } from "./PaymentScreen.vue?vue&type=template&id=60d629fd&scoped=true&"
import script from "./PaymentScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentScreen.vue?vue&type=script&lang=js&"
import style0 from "./PaymentScreen.vue?vue&type=style&index=0&id=60d629fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d629fd",
  null
  
)

export default component.exports